import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import { convertNumbers } from "../../utils/ConvertNumbers";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import { ERROR_COLOR, WHITE } from "../../utils/const";

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontWeight: "normal",
    fontSize: "14px",
    opacity: "0.4",
  },
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

const PBarItem = (props) => {
  return (
    <Grid container>
      <Grid
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingBottom: "24px",
          paddingTop: "24px",
        }}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
      >
        <Typography style={{ color: "#73879c", fontSize: "14px" }}>
          {props.data.name}
        </Typography>
        <Grid container>
          <Grid item xs={10} sm={10} md={10} lg={10}>
            <BootstrapTooltip
              title={convertNumbers("میزان فروش: " + props.data.value + "%")}
            >
              <LinearProgress
                style={{
                  width: "100%",
                  height: "12px",
                  borderRadius: "4px",
                  backgroundColor: "#e6e9ed",
                  marginTop: "5px",
                }}
                variant="determinate"
                value={props.data.value}
                color={"primary"}
              />
            </BootstrapTooltip>
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2}>
            <div style={{ width: "100%", paddingRight: "16px" }}>
              <span>{convertNumbers(props.data.selledValue)}</span>
              <span>/</span>
              <span>{convertNumbers(props.data.registeredValue)}</span>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PBarItem;
